import styled from 'styled-components';

import { FormControl } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';

export const FormStyled = styled.form`
  padding: 20px;
`;

export const DoneIconStyled = styled(DoneIcon)`
  color: green !important;
`;
export const FormControlRadioStyled = styled(FormControl)`
  margin-left: 40px !important;
`;
export const DivSubmitButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: '20px 0';
`
export const DivSpinner = styled.div`
display: flex;
justify-content: center;
margin-top: 20px;
`;

export const DivFormTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;